import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import OfflineStatus from './components/OfflineStatus';
import ErrorBoundary from './components/ErrorBoundary';
import { useNotifications } from './hooks/useNotifications';
import { Notification } from './components/Notification';

// Components
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
import Layout from './components/Layout';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#025B29',
    },
    secondary: {
      main: '#025B29',
    },
  },
  transitions: {
    create: (props = 'all') => `cubic-bezier(0.4, 0, 0.2, 1) ${props} 250ms`,
  },
});

function App() {
  const { notifications } = useNotifications();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
          <Router>
            <Layout>
              <OfflineStatus />
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/notifications" element={<Notifications />} />
              </Routes>
            </Layout>
          </Router>
          {notifications.map((notification) => (
            <Notification
              key={notification.id}
              notification={{
                id: notification.id,
                message: notification.message,
                type: notification.type,
                autoDismiss: notification.autoDismiss
              }}
            />
          ))}
        </ErrorBoundary>
        <ReactQueryDevtools initialIsOpen={false} />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
